import type { Module } from '@pc/core';
import { probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';
import { UpcomingAppointmentsWidget } from './widgets/UpcomingAppointmentsWidget';
import './events';

// All routes use `lazyWithReload` so post-deploy stale shells recover via
// a debounced reload instead of throwing "Failed to fetch dynamically
// imported module".
const CalendarPage = lazyWithReload(
  () => import('./pages/CalendarPage'),
);
const AppointmentNewPage = lazyWithReload(
  () => import('./pages/AppointmentNewPage'),
);
const AppointmentDetailPage = lazyWithReload(
  () => import('./pages/AppointmentDetailPage'),
);
const CalendarSettingsPage = lazyWithReload(
  () => import('./pages/CalendarSettingsPage'),
);

export const calendarModule: Module = {
  id: 'calendar',
  name: 'Calendar',
  description:
    'Store-wide / org-wide / per-user appointment scheduling. Schedule clients + non-client guests + external staff. Email + SMS reminders, public confirm/cancel links, subscribable webcal feeds.',
  basePath: '/calendar',
  routes: [
    { path: '/', element: <CalendarPage /> },
    { path: '/new', element: <AppointmentNewPage /> },
    { path: '/settings', element: <CalendarSettingsPage /> },
    { path: '/:id', element: <AppointmentDetailPage /> },
  ],
  navItems: [{ label: 'Calendar', to: '/calendar', order: 25 }],
  dashboardWidgets: [
    {
      id: 'calendar-upcoming',
      span: 2,
      order: 25,
      render: UpcomingAppointmentsWidget,
    },
  ],
  events: {
    publishes: [
      'calendar.appointment_created',
      'calendar.appointment_updated',
      'calendar.appointment_cancelled',
      'calendar.appointment_confirmed',
      'calendar.staff_contact_upserted',
    ],
  },
  healthProbe: () => probeSchemaIsExposed('calendar', 'v_appointment_summary'),
};
